export const IMAGE_FORMAT = {
  SQUARE: 'square',
  RECTANGLE: 'rectangle',
};

const SQUARE_IMAGE_RATIO_THRESHOLD = 1.2;

export const getImageFormat = ({ width, height }) => {
  if (!width || !height) return null;

  const ratio = Math.max(width, height) / Math.min(width, height);

  return ratio <= SQUARE_IMAGE_RATIO_THRESHOLD
    ? IMAGE_FORMAT.SQUARE
    : IMAGE_FORMAT.RECTANGLE;
};
